import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MWordsComponent } from './words.component';
import { MWordsPipe } from './words.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [MWordsComponent, MWordsPipe],
  exports: [MWordsComponent, MWordsPipe]
})
export class MWordsModule {}
